import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { fetchDosageDiaryProducts } from '../service/fetchDosageDiaryProducts';
import showToast from '../components/ToastComponent';
import { ReactSelectOptionProp } from '../interface/interface';

export function useToFetchAvailableDosageDiaryProducts(
  token: string,
  invoke: number,
): [
  boolean,
  Array<ReactSelectOptionProp>,
  Dispatch<SetStateAction<ReactSelectOptionProp[]>>,
] {
  const [products, setProducts] = useState<Array<ReactSelectOptionProp>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchDosageDiaryProducts(token, {
      available: true,
    }).then((res) => {
      if (typeof res === 'number') {
        showToast({
          message: 'Unable to fetch available products',
          type: 'info',
        });
        setLoading(false);
        return;
      }

      setProducts(res.map((e) => ({ label: e.name, value: e.id.toString() })));
      setLoading(false);
    });
  }, [token, invoke]);

  return [loading, products, setProducts];
}
